import { SectionWrapper } from "../../../../../UI/SectionWrapper/SectionWrapper";
import { Accordion, AccordionSummary } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { AssetAccordionDetails } from "../../../../ui-components/pageLayout/TableSettingsComponents";
import { FieldArray } from "formik";
import { EntitySelectionTable } from "../../../../ui-components/pageLayout/EntitySelectionTable";
import { CMSAsset } from "../../../../../../models/CMS/cmsAsset";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CustomerPortalState, store } from "../../../../store";
import { cmsService } from "../../../../../../http/cms.service";
import {
  GetAssetsAction,
  GetChannelsAction,
  getLiveChannelsSelector,
  getVODsSelector,
} from "../../../../store/reducers/cmsReducer";
import { fromJson } from "../../../../../../models/modelHelpers";

const MediaCollectionMediasAccordion: React.FC = () => {
  const assets = useSelector(getVODsSelector);
  const channels = useSelector(getLiveChannelsSelector);
  const collection = useSelector(
    (state: CustomerPortalState) => state.CMS.collection
  );
  const [selectedAssets, setSelectedAssets] = useState<CMSAsset[]>([]);
  const [filteredChannels, setFilteredChannels] = useState<CMSAsset[]>([]);

  useEffect(() => {
    if (!collection) return;
    if (!collection.assets || collection.assets.length === 0) {
      setSelectedAssets([]);
      return;
    }

    const subscription = cmsService
      .queryAssets({
        assetId: collection.assets,
        pageSize: 10000,
      })
      .subscribe((data) => {
        setSelectedAssets(
          data.assets.map((asset) => fromJson(CMSAsset, asset) as CMSAsset)
        );
      });

    // Cleanup subscription on unmount
    return () => subscription.unsubscribe();
  }, [collection]);

  useEffect(() => {
    if (channels) {
      setFilteredChannels(channels);
    }
  }, [channels]);

  useEffect(() => {
    store.dispatch(GetAssetsAction("page=1&pageSize=50&excludeType=channel"));
    store.dispatch(GetChannelsAction(""));
  }, []);

  const searchFunc = (query: string) => {
    store.dispatch(
      GetAssetsAction(
        `page=1&pageSize=100&excludeType=channel&originalTitle=${query}`
      )
    );
  };

  const channelSearchFunc = (query: string) => {
    setFilteredChannels(
      channels.filter((channel) =>
        channel.getDisplayName().toLowerCase().includes(query.toLowerCase())
      )
    );
  };

  return (
    <SectionWrapper>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          className="accordion-summary-gray"
        >
          Medias
        </AccordionSummary>
        <AssetAccordionDetails>
          <>
            {!!assets.length && (
              <FieldArray
                name="assets"
                render={({ move, push, remove, form }) => (
                  <EntitySelectionTable
                    label="VODs"
                    values={assets}
                    selectedValues={form.values.assets?.map((id) =>
                      selectedAssets.find(
                        (asset) => asset?.getUniqueId() === id
                      )
                    )}
                    searchFunction={searchFunc}
                    push={(entity) => {
                      setSelectedAssets([
                        ...selectedAssets,
                        entity as CMSAsset,
                      ]);
                      push(entity.getUniqueId());
                    }}
                    remove={remove}
                  />
                )}
              />
            )}
            {!!channels.length && (
              <FieldArray
                name="channels"
                render={({ move, push, remove, form }) => (
                  <EntitySelectionTable
                    style={{ marginTop: "25px" }}
                    label="Channels"
                    values={filteredChannels}
                    selectedValues={form.values.channels?.map((id) =>
                      channels.find((channel) => channel?.getUniqueId() == id)
                    )}
                    searchFunction={channelSearchFunc}
                    push={(entity) => push(entity.getUniqueId())}
                    remove={remove}
                  />
                )}
              />
            )}
          </>
        </AssetAccordionDetails>
      </Accordion>
    </SectionWrapper>
  );
};

export default MediaCollectionMediasAccordion;
